// extracted by mini-css-extract-plugin
export default {"dialogs":"Dialogs_dialogs__BK91O","empty":"Dialogs_empty__00cNE"};